import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '../../../components/Button';
import { Modal } from '../../../components/Modal';
import { Spacer } from '../../../components/Spacer';
import { Typography } from '../../../components/Typography';

const PaymentPolicyModal = ({ onClose, open, text }) => {
  return (
    <Modal open={open} onClose={onClose} title='Payment Policy' showHeader>
      <Spacer gap={28} direction='vertical'>
        <Typography style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5em' }}>
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </Typography>
        <Button
          size='small'
          color='primary'
          onClick={onClose}
          style={{ width: 'fit-content', minWidth: '150px' }}
        >
          Okay, got it
        </Button>
      </Spacer>
    </Modal>
  );
};

PaymentPolicyModal.defaultProps = {
  open: false,
  text: '',
};

PaymentPolicyModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  text: PropTypes.string,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  obeeBooking: state.obeeBooking,
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPolicyModal);
